import React, { useState, useEffect, useContext } from "react";
import QuestionYesNoBox from "./../../components/QuestionYesNoBlock";
import { ContainerQuestionYesNoBox } from "./QuestionYesNoContainer.styled";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { useMutation, useLazyQuery } from "@apollo/client";
import {
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
  CREATE_ANSWER_QUESTION_SURVEY,
  UPDATE_DEPENDENCIES,
  UPDATE_MANY_QUESTIONS,
  CREATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION_STATUS,
} from "../../GraphQL/Mutations";
import { getStateLogin } from "../LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";
import { ContextQuestions } from "../../Store/StoreQuestions";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { clientPolicyIngsight } from "../../App";
import { messages } from "../../util/message";
import { theme as themeConfig } from "../../themes/themes";

const QuestionYesNoContainer = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [updateManyQuestions] = useMutation(UPDATE_MANY_QUESTIONS);
  const [dependency, setdependency] = useState([]);
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [showLoader, setshowLoader] = useState(false);

  const [title, setTitle] = useState("");
  const [answerQuestion, setAnswerQuestion] = useState("");
  const [colorPicker, setColorPicker] = useState(themeConfig.primary.purple);
  const [mandatory, setMandatory] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [, setEditable] = useState(true);
  const [elementKey, setelementKey] = useState(2);
  const [refTitle, setRefTitle] = useState("");
  const [refIsMandatory, setRefIsMandatory] = useState(false);
  const [refValidationText, setRefValidationText] = useState("");
  const [refColor, setRefColor] = useState("");
  const [refCategory, setRefCategory] = useState("0");
  const [categories, setcategories] = useState([]);
  const [refCantImage, setCantImage] = useState(0);
  const [createFormQuestion] = useMutation(CREATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestion] = useMutation(UPDATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestionStatus] = useMutation(UPDATE_FORM_QUESTION_STATUS, {
    client: clientPolicyIngsight,
  });
  const [updateDependencies] = useMutation(UPDATE_DEPENDENCIES);
  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [getQuestionCategories, { loading, error }] = useLazyQuery(
    ALL_QUESTION_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          const allCategories = data.allCategoriesQuestion.outputData.map(
            (c) => ({ ...c })
          );
          if (dataSurvey?.isGlobal) {
            setcategories(
              allCategories.filter((f) => f.description === "Global")
            );
          } else {
            setcategories(
              allCategories.filter((f) => f.description !== "Global")
            );
          }
        }
      },
    }
  );
  const [questionSettings, SetQuestionSettings] = useState([
    { id: 1, name: "radioButtonYesNo", value: "yes", color: colorPicker },
    { id: 2, name: "radioButtonYesNo", value: "no", color: colorPicker },
  ]);
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  const [tooltipInformationCheck, setTooltipInformationCheck] = useState(false);
  const [tooltipDescriptionText, setTooltipDescriptionText] = useState("");
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "QuestionYesNo",
    questionSettings: questionSettings,
    tooltip: {
      status: tooltipInformationCheck,
      descriptionText: tooltipDescriptionText,
    },
  });

  const changeTooltipInformationCheck = (status) => {
    configQuestionStyle.tooltip.status = status;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipInformationCheck(status);
  };

  useEffect(() => {
    if (globalProps.GjsonConfiguration !== "") {
      const parsedJSON = JSON.parse(globalProps.GjsonConfiguration);
      if (parsedJSON.tooltip) {
        setTooltipInformationCheck(parsedJSON.tooltip.status);
        setTooltipDescriptionText(parsedJSON.tooltip.descriptionText);
      }
    }
  }, []);

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      let jsonConfSurveyQuestion = JSON.parse(globalProps.GjsonConfiguration);

      setTitle(globalProps.GnameQuestion);
      setRefTitle(globalProps.GnameQuestion);
      setRefCategory(globalProps.GidCategoryQuestion);
      setMandatory(
        globalProps.GisMandatory && globalProps.GisMandatory !== null
          ? globalProps.GisMandatory
          : false
      );
      setRefIsMandatory(globalProps.GisMandatory);
      setRefValidationText(globalProps.GvalidationText);

      SetQuestionSettings(jsonConfSurveyQuestion.questionSettings);
      setconfigQuestionStyle(jsonConfSurveyQuestion);
      setdependency(
        stateQuestionsReducer.questions
          .filter((f) => f.GidParentQuestion === globalProps.GidQuestionSurvey)
          .map((q) => {
            return {
              idQuestionSurvey: q.GidQuestionSurvey,
              isDependent: q.GisDependent,
              idParentQuestion: q.GidParentQuestion,
              dependentAnswer: q.GdependentAnswer,
            };
          })
      );
    }
    getQuestionCategories();
  }, []);

  const OrderQuestions = () => {
    let data = [];
    stateQuestionsReducer.questions.forEach((question, index) => {
      question.Gorder = index + 1;
      question.GindexQuestion = index;
      data.push({
        idQuestionSurvey: question.GidQuestionSurvey,
        order: question.Gorder,
        idQuestion: question.GidQuestion,
      });
    });
    updateManyQuestions({
      variables: {
        questions: { questionSurveys: data },
      },
    }).then((response) => {
      if (response.data.updateManyQuestionSurvey.withError) {
        NotificationManager.error("Error updating questions", "", 5000);
      } else {
        let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
        dispatch({ type: "CLEAN_QUESTIONS" });
        dispatch({ type: "DELETE_QUESTIONS", payload: copy });
      }
      setshowLoader(false);
    });
  };

  let loadCategories = () => {
    if (loading) return <option key="0">Loading...</option>;
    if (error) return <option key="0">Error :(</option>;
    if (!loading && !error)
      return categories.map(
        ({ recordState, description, idCategoryQuestion }) => {
          if (recordState.toUpperCase() === "ACTIVE") {
            return (
              <option key={idCategoryQuestion} value={idCategoryQuestion}>
                {description}
              </option>
            );
          }
          return null;
        }
      );
  };

  let updateInQuestionSurvey = (idInBank, isMandatory, questionSettings) => {
    configQuestionStyle.questionSettings = questionSettings;
    setshowLoader(true);
    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: refCategory,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: refValidationText,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      if (dependency.length) {
        updateDependencies({
          variables: {
            dependencies: dependency,
          },
        }).then((response) => {
          if (response.data.updateQuestionSurveyDependencies.withError) {
            NotificationManager.error("Error to save dependencies", "", 5000);
            setshowLoader(false);
          } else {
            let sortDependency = dependency.sort((a, b) => {
              if (a.dependentAnswer < b.dependentAnswer) {
                return -1;
              }
              if (a.dependentAnswer > b.dependentAnswer) {
                return 1;
              }
              return 0;
            });

            sortDependency.forEach((d) => {
              let position = stateQuestionsReducer.questions.findIndex(
                (i) => i.GidQuestionSurvey === d.idQuestionSurvey
              );
              dispatch({
                type: "UPDATE_QUESTIONS_DEPENDENCY",
                payload: {
                  GindexQuestion: position,
                  GidQuestionSurvey: d.idQuestionSurvey,
                  GisDependent: d.isDependent,
                  GidParentQuestion: d.idParentQuestion,
                  GdependentAnswer: d.dependentAnswer,
                },
              });
              const [reorderedItem] = stateQuestionsReducer.questions.splice(
                position,
                1
              );
              stateQuestionsReducer.questions.splice(
                stateQuestionsReducer.questions.findIndex(
                  (f) => f.GidQuestionSurvey === globalProps.GidQuestionSurvey
                ) + 1,
                0,
                reorderedItem
              );
            });
            OrderQuestions();
          }
        });
      } else {
        setshowLoader(false);
      }
    });
  };

  let saveQuestionSurvey = (
    idQuestion,
    isMandatory,
    questionSettings,
    copyText
  ) => {
    configQuestionStyle.questionSettings = questionSettings;
    setshowLoader(true);
    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      if (copyText !== "") {
        dispatch({
          type: "CLONE_QUESTION",
          payload: {
            Gtype: "QuestionYesNo",
            GindexQuestion: globalProps.GindexQuestion + 1,
            Gactive: true,
            GidSurvey: globalProps.GidSurvey,
            GidQuestion: idQuestion,
            GidCategoryQuestion: refCategory,
            GnameQuestion: title + copyText,
            GvalidationText: refValidationText,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GisMandatory: mandatory,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
            Gorder: globalProps.Gorder + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: null,
            GdependentAnswer: null,
            clonePosition: globalProps.GindexQuestion + 1,
          },
        });
      } else {
        dispatch({
          type: "SAVE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: refCategory,
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: refValidationText,
            GidQuestion: idQuestion,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
      }
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: 3,
          createUser: getStateLogin(),
        },
      })
        .then((data) => {
          if (data.createAnswerQuestionSurvey) {
            NotificationManager.success(
              "New questions were saved successfully",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
      if (dependency.length) {
        let allDependency = [...dependency];
        allDependency.forEach(
          (d) => (d.idParentQuestion = response.data.createQuestionSurvey)
        );
        setdependency(allDependency);
        updateDependencies({
          variables: {
            dependencies: dependency,
          },
        }).then((response) => {
          if (response.data.updateQuestionSurveyDependencies.withError) {
            NotificationManager.error("Error to save dependencies", "", 5000);
            setshowLoader(false);
          } else {
            let sortDependency = dependency.sort((a, b) => {
              if (a.dependentAnswer < b.dependentAnswer) {
                return -1;
              }
              if (a.dependentAnswer > b.dependentAnswer) {
                return 1;
              }
              return 0;
            });

            sortDependency.forEach((d) => {
              let position = stateQuestionsReducer.questions.findIndex(
                (i) => i.GidQuestionSurvey === d.idQuestionSurvey
              );
              dispatch({
                type: "UPDATE_QUESTIONS_DEPENDENCY",
                payload: {
                  GindexQuestion: position,
                  GidQuestionSurvey: d.idQuestionSurvey,
                  GisDependent: d.isDependent,
                  GidParentQuestion: d.idParentQuestion,
                  GdependentAnswer: d.dependentAnswer,
                },
              });
              const [reorderedItem] = stateQuestionsReducer.questions.splice(
                position,
                1
              );
              stateQuestionsReducer.questions.splice(
                stateQuestionsReducer.questions.findIndex(
                  (f) => f.GidQuestionSurvey === globalProps.GidQuestionSurvey
                ) + 1,
                0,
                reorderedItem
              );
            });

            OrderQuestions();
          }
        });
      } else {
        setshowLoader(false);
      }
    });
  };

  const createQuestion = (clone) => {
    let copyText = clone ? " - Copy" : "";
    configQuestionStyle.questionSettings = questionSettings;
    configQuestionStyle.validationText = refIsMandatory
      ? refValidationText
      : "";
    createFormQuestion({
      variables: {
        idForm: globalProps.GidSurvey,
        questionTitle: refTitle + copyText,
        questionType: "QUESTION_YES_NO",
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: refIsMandatory,
        questionOrder: globalProps.Gorder,
      },
    })
      .then((res) => {
        if (res?.data?.createFormQuestion?.idForm) {
          let idQuestion = res.data.createFormQuestion.idQuestionForm;
          if (copyText !== "") {
            dispatch({
              type: "CLONE_QUESTION",
              payload: {
                Gtype: "QuestionYesNo",
                GindexQuestion: globalProps.GindexQuestion + 1,
                Gactive: true,
                GidSurvey: globalProps.GidSurvey,
                GidQuestion: idQuestion,
                GidCategoryQuestion: "",
                GnameQuestion: refTitle + copyText,
                GvalidationText: refIsMandatory ? refValidationText : "",
                GidQuestionSurvey: idQuestion,
                GisMandatory: refIsMandatory,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
                Gorder: globalProps.Gorder + 1,
                GisEdit: false,
                GisDependent: false,
                GidParentQuestion: null,
                GdependentAnswer: null,
                clonePosition: globalProps.GindexQuestion + 1,
              },
            });
          } else {
            dispatch({
              type: "SAVE_QUESTIONS",
              payload: {
                GindexQuestion: globalProps.GindexQuestion,
                GisEdit: false,
                GnameQuestion: refTitle,
                GidCategoryQuestion: "",
                GisMandatory: refIsMandatory,
                Gorder: globalProps.Gorder,
                GvalidationText: refIsMandatory ? refValidationText : "",
                GidQuestion: idQuestion,
                GidQuestionSurvey: idQuestion,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
              },
            });
          }
          setshowLoader(false);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  const updateQuestion = () => {
    configQuestionStyle.questionSettings = questionSettings;
    configQuestionStyle.validationText = refIsMandatory
      ? refValidationText
      : "";
    updateFormQuestion({
      variables: {
        idQuestionForm: globalProps.GidQuestion,
        questionTitle: refTitle,
        questionType: "QUESTION_YES_NO",
        isMandatory: refIsMandatory,
        questionOrder: globalProps.Gorder,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
      },
    })
      .then((res) => {
        dispatch({
          type: "UPDATE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: refTitle,
            GidCategoryQuestion: "",
            GisMandatory: refIsMandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: refIsMandatory ? refValidationText : "",
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
        setshowLoader(false);
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };
  const saveFormQuestion = (clone) => {
    let title = refTitle;
    let isMandatory = refIsMandatory;
    let validationText = refValidationText;
    if (
      title.trim() !== "" &&
      ((isMandatory && validationText.trim() !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText.trim() !== "") ||
        !isMandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        setshowLoader(true);
        if (isMandatory && validationText !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestion();
          } else {
            createQuestion(clone);
          }
        } else {
          if (!isMandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          } else if (isMandatory && validationText === "") {
            setshowLoader(true);
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let saveQuestionBank = (clone) => {
    let title = refTitle;
    let category = refCategory;
    let isMandatory = refIsMandatory;
    let validationText = refValidationText;
    if (
      title.trim() !== "" &&
      parseInt(category) !== 0 &&
      ((isMandatory && validationText.trim() !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText !== "") ||
        !isMandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        setshowLoader(true);
        let copyText = clone ? " - Copy" : "";
        if (isMandatory && validationText !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestionBank({
              variables: {
                idQuestion: globalProps.GidQuestion,
                nameQuestion: title,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                lastUpdateUser: getStateLogin(),
              },
            }).then(() => {
              updateInQuestionSurvey(
                globalProps.GidQuestion,
                isMandatory,
                questionSettings
              );
            });
          } else {
            createQuestionBank({
              variables: {
                nameQuestion: title + copyText,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                createUser: getStateLogin(),
              },
            }).then((saveResponse) => {
              saveQuestionSurvey(
                saveResponse.data.createQuestionBank,
                isMandatory,
                questionSettings,
                copyText
              );
            });
          }
        } else {
          if (!isMandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  questionSettings
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  questionSettings,
                  copyText
                );
              });
            }
          } else if (mandatory && validationText === "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  questionSettings
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  questionSettings,
                  copyText
                );
              });
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoCategory();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let handleNoQuestionTitle = () => {
    if (refTitle.trim() === "") {
      NotificationManager.warning(messages.QuestionTitle);
    }
  };

  let handleNoCategory = () => {
    if (parseInt(refCategory) === 0) {
      NotificationManager.warning(messages.QuestionCategory);
    }
  };

  let handleNoMandatoryText = () => {
    if (refIsMandatory && refValidationText === "") {
      NotificationManager.warning(messages.QuestionMandatory);
    }
  };

  let handleNoTooltipDesMessage = () => {
    if (tooltipInformationCheck && tooltipDescriptionText === "") {
      NotificationManager.warning(messages.QuestionTooltipDescription);
    }
  };

  let handleEdit = () => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
  };

  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];

    let jsonConfSurveyQuestion = JSON.parse(objG.GjsonConfiguration);

    setTitle(objG.GnameQuestion);
    setRefTitle(objG.GnameQuestion);
    setRefCategory(objG.GidCategoryQuestion);
    setMandatory(
      objG.GisMandatory && objG.GisMandatory !== null
        ? objG.GisMandatory
        : false
    );
    setRefIsMandatory(objG.GisMandatory);
    setRefValidationText(objG.GvalidationText);
    SetQuestionSettings(jsonConfSurveyQuestion.questionSettings);
    setconfigQuestionStyle(jsonConfSurveyQuestion);
    setdependency(
      stateQuestionsReducer.questions
        .filter((f) => f.GidParentQuestion === globalProps.GidQuestionSurvey)
        .map((q) => {
          return {
            idQuestionSurvey: q.GidQuestionSurvey,
            isDependent: q.GisDependent,
            idParentQuestion: q.GidParentQuestion,
            dependentAnswer: q.GdependentAnswer,
          };
        })
    );

    if (jsonConfSurveyQuestion.tooltip) {
      setTooltipInformationCheck(jsonConfSurveyQuestion.tooltip.status);
      setTooltipDescriptionText(jsonConfSurveyQuestion.tooltip.descriptionText);
    }

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });
  };
  const deleteNonSavedQuestion = () => {
    setshowLoader(false);
    let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
    copy.questions.splice(globalProps.GindexQuestion, 1);
    copy.questions.forEach((q, index) => {
      q.GindexQuestion = index;
      q.Gorder = index + 1;
    });
    dispatch({ type: "CLEAN_QUESTIONS" });
    dispatch({ type: "DELETE_QUESTIONS", payload: copy });
  };

  const handleDeleteFormQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestion) {
      updateFormQuestionStatus({
        variables: {
          idFormQuestion: globalProps.GidQuestion,
          newFormQuestionStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res?.data?.changeStatusFormQuestion?.idQuestionForm) {
            setshowLoader(false);
            let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
            copy.questions.splice(globalProps.GindexQuestion, 1);
            copy.questions.forEach((q, index) => {
              q.GindexQuestion = index;
              q.Gorder = index + 1;
            });
            dispatch({ type: "CLEAN_QUESTIONS" });
            dispatch({ type: "DELETE_QUESTIONS", payload: copy });
          }
        })
        .catch((error) => {
          NotificationManager.error(error.message, "", 5000);
        });
    } else {
      deleteNonSavedQuestion();
    }
  };

  let handleDelete = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          setshowLoader(false);
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));

          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.forEach((q, index) => {
            if (q.GidParentQuestion === globalProps.GidQuestionSurvey) {
              q.GdependentAnswer = "";
              q.GidParentQuestion = 0;
              q.GisDependent = false;
            }
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      deleteNonSavedQuestion();
    }
  };

  const saveDependencies = (Questions) => {
    setdependency(Questions);
  };

  let handleTextAreaText = (value) => {
    setTooltipDescriptionText(value);
    configQuestionStyle.tooltip.descriptionText = value;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
  };

  return (
    <>
      <ContainerQuestionYesNoBox>
        <QuestionYesNoBox
          title={title}
          setTitle={setTitle}
          answerQuestion={answerQuestion}
          setAnswerQuestion={setAnswerQuestion}
          questionSettings={questionSettings}
          SetQuestionSettings={SetQuestionSettings}
          colorPicker={colorPicker}
          setColorPicker={setColorPicker}
          mandatory={mandatory}
          setMandatory={setMandatory}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          alreadySaved={globalProps.GisEdit ? false : true}
          editable={globalProps.GisEdit}
          setEditable={setEditable}
          elementKey={elementKey}
          setelementKey={setelementKey}
          loadCategories={loadCategories}
          refTitle={refTitle}
          setRefTitle={setRefTitle}
          refIsMandatory={refIsMandatory}
          setRefIsMandatory={setRefIsMandatory}
          refValidationText={refValidationText}
          setRefValidationText={setRefValidationText}
          refColor={refColor}
          setRefColor={setRefColor}
          refCategory={refCategory}
          setRefCategory={setRefCategory}
          saveQuestionBank={saveQuestionBank}
          handleEdit={handleEdit}
          handleCancel={handleCancel}
          refCantImage={refCantImage}
          setCantImage={setCantImage}
          error={error}
          loading={loading}
          configQuestionStyle={configQuestionStyle}
          setconfigQuestionStyle={setconfigQuestionStyle}
          handleDeleteQuestion={() => {
            if (identity !== "form") {
              handleDelete();
            } else {
              handleDeleteFormQuestion();
            }
          }}
          idQuestionSurvey={globalProps.GidQuestionSurvey}
          saveDependencies={saveDependencies}
          dependency={dependency}
          globalProps={globalProps}
          categories={categories}
          identity={identity}
          saveFormQuestion={saveFormQuestion}
          tooltipInformationCheck={tooltipInformationCheck}
          tooltipDescriptionText={tooltipDescriptionText}
          setShowTooltipDescription={setShowTooltipDescription}
          handleTextAreaText={handleTextAreaText}
          changeTooltipInformationCheck={changeTooltipInformationCheck}
          showTooltipDescription={showTooltipDescription}
        />
      </ContainerQuestionYesNoBox>
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};

export default QuestionYesNoContainer;
